module.exports = __webpack_public_path__ + "images/map-style-3-0a32036cf4fa58c67c7f1f2ef39ad233.jpg";